var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 262,
    viewBox: "0 0 302 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.298,
    y: 107.391,
    width: 49.0916,
    height: 166.366,
    rx: 21.8185,
    transform: "rotate(-89.7079 134.298 107.391)",
    fill: "#325EE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.727,
    y: 166.913,
    width: 49.0916,
    height: 166.366,
    rx: 21.8185,
    transform: "rotate(-179.708 241.727 166.913)",
    fill: "#325EE9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.299011,
    y: 201.726,
    width: 49.0916,
    height: 166.366,
    rx: 21.8185,
    transform: "rotate(-89.7079 0.299011 201.726)",
    fill: "#325EE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.728,
    y: 260.913,
    width: 49.0916,
    height: 166.366,
    rx: 21.8185,
    transform: "rotate(-179.708 107.728 260.913)",
    fill: "#325EE9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus1);
export default __webpack_public_path__ + "static/media/plus-1.1250447d155a608cb775161fce22f5ce.svg";
export { ForwardRef as ReactComponent };